import {createBrowserRouter, Navigate, useNavigate} from 'react-router-dom';
import App from './App';
import React, {useEffect} from "react";
import Dashboard from './pages/dashboard/dashboard';
import {Login} from './pages/login/login';
import useAuth from "./hooks/useAuth";
import {InstallerLogin} from './pages/login/installerLogin';
import useData from './hooks/useData';


interface ProtectedRouteProps {
    children: any;
}

export const ProtectedRoute = (props: ProtectedRouteProps) => {

    const {token, loginInProgress} = useAuth();
    const {isInstaller, installerToken, dataProviderInitialized} = useData();
    const navigate = useNavigate();

    useEffect(() => {
        if (dataProviderInitialized && (!token && !loginInProgress && !isInstaller)) {
            navigate('/login');
        } else if (dataProviderInitialized && (isInstaller && !installerToken)) {
            navigate("/installer/login")
        }
    }, [token, loginInProgress, installerToken, isInstaller, dataProviderInitialized]);

    return props.children;
};

export const LoginRedirect = (props: ProtectedRouteProps) => {

    const {token} = useAuth();
    const {isInstaller, installerToken, dataProviderInitialized} = useData();
    const navigate = useNavigate();

    useEffect(() => {
        if (dataProviderInitialized && ((token && !isInstaller) || (isInstaller && installerToken))) {
            navigate('/');
        }
    }, [token, isInstaller, installerToken, dataProviderInitialized]);

    return props.children;
};

export const router = createBrowserRouter([
    {
        path: '/',
        element: <App/>,
        children: [
            {
                path: '',
                element: <ProtectedRoute><Dashboard/></ProtectedRoute>
            },
            {
                path: 'login',
                element: <LoginRedirect><Login/></LoginRedirect>
            },
            {
                path: 'installer/login',
                element: <LoginRedirect><InstallerLogin/></LoginRedirect>
            },
            {
                path: '*',
                element: <Navigate replace to="/login"></Navigate>
            }
        ]
    }
]);
